import styled from "styled-components";

const Holder = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding-top: 8px;
`;

const RetentionGraphPlaceholder = () => {
  return (
    <Holder>
      <svg
        width="122"
        height="54"
        viewBox="0 0 122 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M152 52.0001V9.24929e-05C85 9.24919e-05 61.5 -0.000115616 0 9.24929e-05V52.0001H152Z"
          fill="url(#paint0_linear_5484_141049)"
        />
        <line
          x1="8.74228e-08"
          y1="51"
          x2="152"
          y2="51"
          stroke="#5D54D6"
          strokeWidth="2"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5484_141049"
            x1="76"
            y1="0.000976754"
            x2="76"
            y2="52.001"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5D54D6" stopOpacity="0.25" />
            <stop offset="1" stopColor="#5D54D6" stopOpacity="0.05" />
          </linearGradient>
        </defs>
      </svg>
    </Holder>
  );
};

export default RetentionGraphPlaceholder;
